/* eslint-disable no-template-curly-in-string */
// @flow

export default {
  NoRecordsFound: '기록을 찾을 수 없습니다.',
  DocumentIndex: '문서 인덱스',
  SubmissionIndex: '제출 인덱스',
  Search: '찾다',
  Searching: '수색...',
  Filter: '필터',
  FullTextSearch_SentenceCase: '전체 텍스트 검색',
  BulkDownload_SentenceCase: '대량 다운로드',
  ExportToExcel: 'Excel로 내보내기',
  ExpandAll_SentenceCase: '모두 확장',
  CollapseAll_SentenceCase: '모두 접기',
  BulkDownloadName_SentenceCase: '패키지 이름',
  SelectAll_SentenceCase: '모두 선택',
  AskQuestion: '질문하기',
  Move: '이동하다',
  Edit: '편집하다',
  OpenInOfficeOnline: '웹용 Microsoft Office 에서 열기',
  EditInOfficeOnline: '웹용 Microsoft Office 에서 편집',
  Security: '보안',
  Enable: '할 수 있게 하다',
  Disable: '비활성화',
  Delete: '삭제',
  History: '기록',
  History_LowerCase: '기록',
  ManageDocuments: '문서 관리',
  SelectDocumentsToRedact: '삭제할 문서를 선택하세요',
  Submissions: '제출',
  TenderSubmissions: '입찰 제출',
  Add: '추가하다',
  Folder: '접는 사람',
  Document: '문서',
  Document_LowerCase: '문서',
  Documents_LowerCase: '서류',
  Folder_LowerCase: '접는 사람',
  Folders_LowerCase: '폴더',
  Renumber: '다시 세다',
  BulkUpload_SentenceCase: '대량 업로드',
  BulkDownloadOverDownloadLimit:
    '다운로드 크기 제한인 100GB 에 도달했습니다. 계속하려면 선택에서 파일을 제거하세요.',
  Name_: '이름:',
  Number_: '숫자:',
  Retry: '다시 해 보다',
  FolderNotDeletedAccess:
    '오류: 폴더에 액세스할 수 없는 문서 및/또는 하위 폴더가 하나 이상 포함되어 있으므로 폴더를 삭제할 수 없습니다.',
  FolderNotDeleted: '오류: 폴더를 삭제할 수 없습니다.',
  DocumentNotDeleted: '오류: 문서를 삭제할 수 없습니다.',
  FolderNotUpdated: '오류: 폴더를 업데이트할 수 없습니다.',
  DocumentNotUpdated: '오류: 문서를 업데이트할 수 없습니다.',
  ParentFolderDisabled: '부모 폴더가 비활성화되었습니다',
  EnableDocument:
    '이 폴더에는 문서 1개가 들어 있습니다. 이 폴더를 활성화하시겠습니까?',
  EnableDocuments: '\u003cb\u003e문서 활성화\u003c/b\u003e',
  EnableFolder:
    '이 폴더에는 1개의 폴더가 있습니다. 이 폴더를 활성화하시겠습니까?',
  EnableFolderDocument:
    '이 폴더에는 폴더 1개와 문서 1개가 포함되어 있습니다. 이 폴더를 활성화하시겠습니까?',
  EnableFolderDocuments:
   '이 폴더에는 1개의 폴더와 ${NumberOfDocuments} 문서가 포함되어 있습니다. 이 폴더를 활성화하시겠습니까?',
  EnableFolders:
   '이 폴더에는 ${NumberOfFolders} 폴더가 포함되어 있습니다. 이 폴더를 활성화하시겠습니까?',
  EnableFoldersDocument:
   '이 폴더에는 ${NumberOfFolders} 폴더와 1개의 문서가 포함되어 있습니다. 이 폴더를 활성화하시겠습니까?',
  EnableFoldersDocuments:
    '이 폴더에는 ${NumberOfFolders} 폴더와 ${NumberOfDocuments} 문서가 포함되어 있습니다. 이 폴더를 활성화하시겠습니까?',
  BulkEnableFolders: '${NumberOfFolders} 폴더가 활성화됩니다.',
  BulkEnableFoldersWithImplicitFolders:
    '이러한 항목을 활성화하려면 모든 상위 폴더를 활성화해야 합니다. ${NumberOfFolders} 폴더가 활성화됩니다.',
  BulkEnableOneFolder: '1개의 폴더가 활성화됩니다.',
  BulkEnableOneFolderAndDocuments:
    '1개의 폴더와 ${NumberOfDocuments} 문서가 활성화됩니다.',
  BulkEnableOneFolderAndDocumentsWithImplicitFolders:
    '이러한 항목을 사용하려면 모든 상위 폴더를 활성화해야 합니다. 1개의 폴더와 ${NumberOfDocuments} 문서가 활성화됩니다.',
  BulkEnableOneFolderAndOneDocument: '1개의 폴더와 1개의 문서가 활성화됩니다.',
  BulkEnableOneFolderAndOneDocumentWithImplicitFolders:
    '이러한 항목을 활성화하려면 모든 상위 폴더를 활성화해야 합니다. 1개의 폴더와 1개의 문서가 활성화됩니다.',
  BulkEnableDocuments: '${NumberOfDocuments} 문서가 활성화됩니다.',
  BulkEnableOneDocument: '1개 문서가 활성화됩니다.',
  BulkEnableFoldersAndOneDocument:
    '${NumberOfFolders} 폴더와 1개 문서가 활성화됩니다.',
  BulkEnableFoldersAndOneDocumentWithImplicitFolders:
    '이러한 항목을 활성화하려면 모든 상위 폴더를 활성화해야 합니다. ${NumberOfFolders} 폴더와 1개 문서가 활성화됩니다.',
  BulkEnableFoldersAndDocuments:
    '${NumberOfFolders} 폴더와 ${NumberOfDocuments} 문서가 활성화됩니다.',
  BulkEnableFoldersAndDocumentsWithImplicitFolders:
    '이러한 항목을 활성화하려면 모든 상위 폴더를 활성화해야 합니다. ${NumberOfFolders} 폴더와 ${NumberOfDocuments} 문서가 활성화됩니다.',
  BulkEnableDocumentsErrorMessage:
    '오류: ${NumberOfDocuments} 문서를 활성화할 수 없습니다.',
  BulkEnableFoldersErrorMessage:
    '오류: ${NumberOfFolders} 폴더를 활성화할 수 없습니다.',
  BulkEnableFoldersDocumentsErrorMessage:
    '오류: ${NumberOfFolders} 폴더 및 ${NumberOfDocuments} 문서를 활성화할 수 없습니다.',
  DisableDocument:
    '이 폴더에는 1개의 문서가 포함되어 있습니다. 이 폴더를 비활성화하시겠습니까?',
  DisableDocuments: '\u003cb\u003e문서 비활성화\u003c/b\u003e',
  DisableFolder:
    '이 폴더에는 1개의 폴더가 있습니다. 이 폴더를 비활성화하시겠습니까?',
  DisableFolderDocument:
    '이 폴더에는 폴더 1개와 문서 1개가 포함되어 있습니다. 이 폴더를 비활성화하시겠습니까?',
  DisableFolderDocuments:
    '이 폴더에는 1개의 폴더와 ${NumberOfDocuments} 문서가 포함되어 있습니다. 이 폴더를 비활성화하시겠습니까?',
  DisableFolders:
    '이 폴더에는 ${NumberOfFolders} 폴더가 포함되어 있습니다. 이 폴더를 비활성화하시겠습니까?',
  DisableFoldersDocument:
    '이 폴더에는 ${NumberOfFolders} 폴더와 1개의 문서가 포함되어 있습니다. 이 폴더를 비활성화하시겠습니까?',
  DisableFoldersDocuments:
    '이 폴더에는 ${NumberOfFolders} 폴더와 ${NumberOfDocuments} 문서가 포함되어 있습니다. 이 폴더를 비활성화하시겠습니까?',
  DisableFolderConfirm:
    '"${FolderName}" 폴더 안에는 다른 폴더가 포함되어 있으며, 해당 폴더도 비활성화됩니다.',
  BulkDisableFolders: '${NumberOfFolders} 폴더가 비활성화됩니다.',
  BulkDisableOneFolder: '1 개 폴더가 비활성화됩니다.',
  BulkDisableOneFolderAndDocuments:
    '1 개의 폴더와 ${NumberOfDocuments} 문서가 비활성화됩니다.',
  BulkDisableOneFolderAndOneDocument:
    '1 개의 폴더와 1개의 문서가 비활성화됩니다.',
  BulkDisableDocuments: '${NumberOfDocuments} 문서가 비활성화됩니다.',
  BulkDisableOneDocument: '1 개 문서가 비활성화됩니다.',
  BulkDisableFoldersAndOneDocument:
    '${NumberOfFolders} 폴더와 1개 문서가 비활성화됩니다.',
  BulkDisableFoldersAndDocuments:
    '${NumberOfFolders} 폴더와 ${NumberOfDocuments} 문서가 비활성화됩니다.',
  BulkDisableDocumentsErrorMessage:
    '오류: ${NumberOfDocuments} 문서를 비활성화할 수 없습니다.',
  BulkDisableFoldersErrorMessage:
    '오류: ${NumberOfFolders} 폴더를 비활성화할 수 없습니다.',
  BulkDisableFoldersDocumentsErrorMessage:
    '오류: ${NumberOfFolders} 폴더와 ${NumberOfDocuments} 문서를 비활성화할 수 없습니다.',
  DeleteFileConfirmation: '"${FileName}" 는 즉시 삭제됩니다.',
  DeleteFolderConfirmation: '"${FolderName}" 는 즉시 삭제됩니다.',
  BulkDeleteFolders: '${NumberOfFolders} 폴더가 삭제됩니다.',
  BulkDeleteOneFolder: '1 개의 폴더가 삭제됩니다.',
  BulkDeleteOneFolderAndDocuments:
    '1 개의 폴더와 ${NumberOfDocuments} 문서가 삭제됩니다.',
  BulkDeleteOneFolderAndOneDocument: '1 개의 폴더와 1개의 문서가 삭제됩니다.',
  BulkDeleteDocuments: '${NumberOfDocuments} 문서가 삭제됩니다.',
  BulkDeleteOneDocument: '1 개 문서가 삭제됩니다.',
  BulkDeleteFoldersAndOneDocument:
    '${NumberOfFolders} 폴더와 1개 문서가 삭제됩니다.',
  BulkDeleteFoldersAndDocuments:
    '${NumberOfFolders} 폴더와 ${NumberOfDocuments} 문서가 삭제됩니다.',
  BulkDeleteDocumentsErrorMessage:
    '오류: ${NumberOfDocuments} 문서를 삭제할 수 없습니다.',
  BulkDeleteFoldersErrorMessage:
    '오류: ${NumberOfFolders} 폴더를 삭제할 수 없습니다.',
  BulkDeleteFoldersDocumentsErrorMessage:
    '오류: ${NumberOfFolders} 폴더와 ${NumberOfDocuments} 문서를 삭제할 수 없습니다.',
  AddFolder: '폴더 추가',
  AddDocument: '문서 추가',
  CopyLink_SentenceCase: '링크 복사',
  SendToKira_SentenceCase: '키라에게 보내다',
  Actions: '행위',
  Download: '다운로드',
  DownloadPart: '다운로드 부분 ${number}',
  BulkDownloadIsNotSwitchedOnContactAdmin_Gen2:
    '대량 다운로드가 켜지지 않았습니다. 자세한 내용은 관리자에게 문의하세요.',
  Disabled: '비활성화됨',
  FileTypeUnknown: '파일',
  FileTypeAcrobat: '아크로뱃 PDF',
  FileTypeArchive: '보관소',
  FileTypeAudio: '오디오 파일',
  FileTypeCode: '암호',
  FileTypeContact: '연락하다',
  FileTypeEmail: '이메일',
  FileTypeExcel: '뛰어나다',
  FileTypeImage: '영상',
  FileTypeLayoutAndDesign: '디자인 문서',
  FileTypePowerpoint: '파워포인트',
  FileTypeText: '텍스트',
  FileTypeVideo: '동영상',
  FileTypeVisio: '비지오',
  FileTypeWord: '단어',
  SavingAllowed: '저장이 허용되었습니다',
  SavingDenied: '저장 거부됨',
  PrintingAllowed: '인쇄 허용',
  PrintingDenied: '인쇄 거부',
  FileExtensionEmpty: '확장자 없음',
  OneBulkDownloadInProgress: '1개의 대량 다운로드가 진행 중입니다 - ${progress}%',
  NumberOfBulkDownloadInProgress:
    '${number} 대량 다운로드 진행 중 - ${progress}%',
  Cancel: '취소',
  Expand: '확장하다',
  Collapse: '무너지다',
  FolderEmpty: '폴더가 비어있습니다',
  UseChromeToBulkUpload: 'Chrome 을 사용하여 문서와 폴더를 대량으로 업로드하세요.',
  RenumberCallToAction: '다시 세다',
  Archives: '아카이브',
  BulkDownloadUnavailable:
    '현재 대량 다운로드를 사용할 수 없습니다. 나중에 다시 시도하세요.',
  PreviewNotAvailable: '미리보기가 제공되지 않습니다.',
  DocumentIsTooLargeToPreview:
    '이 문서는 미리 보기에 너무 큽니다. 문서를 다운로드해야 볼 수 있습니다.',
  DocumentIsTooLargeToPreviewWithoutDownload:
    '이 문서는 너무 커서 미리 볼 수 없습니다.',
  FileCannotBePreviewed: '이 파일은 미리 볼 수 없습니다.',
  OwnerHasSecuredThisDocument: '소유자가 이 문서를 확보했습니다.',
  ThisDocumentIsSecuredWithAdobeRightsManagement:
    '이 문서는 Adobe Rights Management로 보호됩니다. 이 문서를 보려면 Adobe Acrobat Reader 가 필요하고 온라인 상태여야 합니다.',
  ThisDocumentIsSecuredWithMicrosoftRightsManagement:
    '이 문서는 Microsoft Rights Management로 보호됩니다. 이 문서를 보려면 Microsoft Office 가 필요하고 온라인 상태여야 합니다.',
  SecuredPdfHelpLink:
    'PDF 문서 보기에 대해 자세히 알아보세요. \u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-pc\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003e',
  SecuredPdfHelpLinkMac:
    'PDF 문서 보기에 대해 자세히 알아보세요. \u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-mac\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003e',
  SecuredDocHelpLink:
    '\u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eOffice 문서 보기에 대해 자세히 알아보세요.\u003c/a\u003e',
  YourDownloadIsBeingPrepared: '다운로드를 준비 중입니다...',
  OwnerHasSecuredTheseDocuments: '소유자는 이 문서를 확보했습니다.',
  SecuredPdfAndDocHelpLink:
    '자세히 알아보려면 \u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-pc\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003ePDF 문서 보기\u003c/a\u003e또는 \u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eOffice 문서를 참조하세요.\u003c/a\u003e',
  SecuredPdfAndDocHelpLinkMac:
    '자세히 알아보려면 \u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-mac\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003ePDF 문서 보기\u003c/a\u003e또는 \u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eOffice 문서를 참조하세요.\u003c/a\u003e',
  DocumentsAreSecuredWithMicrosoftOrAdobeRightsManagement:
    '이 문서는 Adobe Rights Management 또는 Microsoft Rights Management 로 보호됩니다. Adobe Acrobat Reader 또는 Microsoft Office 가 필요하며 온라인 상태여야 이 문서를 볼 수 있습니다.',
  UnableToDownloadThisFileTryAgain: '이 파일을 다운로드할 수 없습니다.',
  DownloadStarted: '다운로드 시작됨',
  Close: '닫다',
  GotIt: '알았어요',
  Preview: '시사',
  DontShowThisAgain: '다시 표시하지 마세요',
  BulkDownloadPrepareTitle: '다운로드를 준비 중입니다...',
  BulkDownloadPrepareAwareMessage:
    '다운로드 크기가 클수록 처리하는 데 시간이 더 오래 걸릴 수 있습니다.',
  BulkDownloadPrepareMessage:
    '다운로드가 준비되면 <strong>${email}</strong> 주소로 이메일이 전송됩니다.',
  BulkDownloadLimitError:
    '${limitedNumberOfItems} 파일 또는 ${limitedFileSize}의 다운로드 제한에 도달했습니다. 계속하려면 선택 항목에서 파일을 제거하세요.',
  LinkCopiedToClipboard: '링크가 클립보드에 복사되었습니다',
  RestoreDocuments: '문서 복원',
  RepairNumbering: '수리 번호',
  BulkUpdate: '대량 업데이트',
  GenerateFolders: '폴더 생성',
  NotificationsReport: '알림 보고서',
  DownloadHelpInfo:
    "몇 초 후에도 다운로드가 시작되지 않으면 다음을 사용하세요.",
  DirectLink: '직접 링크',
  YourDocumentsAreDownloading: '문서를 다운로드하는 중입니다.',
  DocumentRenamed: '문서 이름이 변경되었습니다.',
  FolderRenamed: '폴더 이름이 변경되었습니다.',
  FolderRenamedRenumber: '폴더 내용을 업데이트하려면 번호를 다시 매기세요',
  DocumentsNotificationList: '문서 알림 목록',
  UserDocumentNotificationSettings: '사용자 문서 알림 설정',
  IntervalType: '간격 유형',
  NumberOfUsers: '사용자 수',
  NotificationList: '알림 목록',
  ExportSelectedItemsToExcel: '[Number]을 Excel 로 내보내기',
  ToEmail: '이메일로 보내기',
  FromSentDateSydneyTime: '보낸 날짜(시드니 시간)',
  ToSentDateSydneyTime: '보낸 날짜(시드니 시간)',
  DocID: '문서 ID',
  DocName: '문서 이름',
  To: '에게',
  UserType: '사용자 유형',
  SentDateSydneyTime: '발송일(시드니 시간)',
  Previous: '이전의',
  Next: '다음',
  DisableFolderConfirmHeader: '폴더를 비활성화하려고 합니다.',
  ThereAreNoAvailableFoldersAndDocumentsAtTheMoment:
    '현재 이용 가능한 문서나 폴더가 없습니다.',
  ThereAreNoDocumentsOrFoldersMatchingFilterCriteria:
    '필터 기준과 일치하는 문서나 폴더가 없습니다.',
  DeleteFolderConfirmHeader: '폴더를 삭제하려고 합니다.',
  DeleteFileConfirmHeader: '파일을 삭제하려고 합니다.',
  MoveItemDialogUseDestinationFolderSecurity:
    '${destinationFolderName} 에서 폴더 보안 설정을 사용하세요.',
  MoveItemDialogSecuritySettingsLabel: '보안 설정',
  MoveItemDialogUseCurrentFolderSecurity: '현재 보안 설정 사용',
  MoveItemDialogNotifyCheckbox: '접근 권한이 부여되면 사람들에게 알림',
  MoveItemNewLocation: '새로운 위치: ',
  DontHavePermissionToMoveFolder:
    "이 폴더를 이동할 수 있는 권한이 없습니다.",
  DontHavePermissionToMoveFolders:
    "이 폴더를 이동할 수 있는 권한이 없습니다.",
  DontHavePermissionToMoveItemsMoveIntoFolder:
    "이 폴더로 항목을 이동할 수 있는 권한이 없습니다.",
  SecuredFileIsTooLargeToPreview:
    "미리 보려는 파일이 너무 큽니다. 대신 다운로드할 수 있습니다.",
  SecuredFileIsTooLargeToPreviewWithoutDownload:
    "미리보려는 파일이 너무 큽니다.",
  BeforeYouDownload: '다운로드하기 전에',
  SecuredPreviewPdfHelpLink:
    '\u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-pc\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003ePDF 문서 보기에 대해 자세히 알아보세요.\u003c/a\u003e',
  SecuredPreviewPdfHelpLinkMac:
    '\u003ca href=\u0022https://help.ansarada.com/troubleshooting/pdfs/unable-to-access-pdfs-mac\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003ePDF 문서 보기에 대해 자세히 알아보세요.\u003c/a\u003e',
  SecuredPreviewDocHelpLink:
    '\u003ca href=\u0022https://help.ansarada.com/collaborate-team-and-deal/access-transaction-room-files/view-secure-office-files\u0022 target=\u0022_blank\u0022 class=\u0022ace-helplink\u0022\u003eOffice 문서 보기에 대해 자세히 알아보세요.\u003c/a\u003e',
  StartYourDataRoomAndAddDocument: '데이터룸을 시작하고 문서를 추가하세요.',
  UploadDocuments: '문서 업로드',
  ExpiredDocumentAccess:
    '이 문서에 대한 귀하의 액세스가 만료되었습니다. 데이터 룸 관리자에게 연락하여 액세스하세요.',
  MultipleDragDropInfo: '이동할 문서 및 폴더를 선택, 드래그 앤 드롭하세요',
  DemoMultipleDragDropTitle: '작동 원리',
  Zipping: '지퍼',
  Processing: '처리 중...',
  YourFilesAreReadyToDownload: '파일을 다운로드할 준비가 되었습니다.',
  ThisBulkDownloadIsSplit:
    '이 다운로드는 너무 커서 여러 부분으로 나눴습니다. 이 링크는 이메일에서도 찾을 수 있습니다.',
  BulkDownloadEmptyFoldersNote: '빈 폴더는 다운로드되지 않습니다.',
  NotifyPeopleWhenAccessIsGranted: '접근 권한이 부여되면 사람들에게 알림',
  BulkEnableConfirmHeader: '폴더 및 문서 활성화',
  BulkDisableConfirmHeader: '폴더 및 문서 비활성화',
  CopyDocumentsInProgress: '문서 인덱스 로드 진행 중',
  SomeDocumentsAreSecuredLink:
    '일부 문서는 관리자에 의해 보호됩니다. 이를 열려면 다음이 필요합니다.',
  EnableTruncation: '잘림 활성화',
  OptimizeFilePathForWindows: 'Windows 용 파일 경로 최적화',
  TruncationNoteForWindows:
    'Windows 사용자의 경우 Windows 10 에서 7-Zip 을 사용하여 압축을 풀어야 합니다.',
  Restore: '복원하다',
  Current: '현재의',
  AddedBy: '추가됨',
  UpdatedBy: '업데이트됨',
  RestoreThisVersion: '이 버전을 복원하세요',
  AdobeAcrobatReader: '어도비 아크로뱃 리더',
  MicrosoftOffice: '마이크로소프트 오피스',
  InternetConnection: '인터넷 연결',
  BulkDeleteConfirmHeader: '폴더 및 문서 삭제',
  Preparing: '준비 중...',
  SomeSavingDeniedFilesSelected:
    '${number} 문서에는 "저장 거부" 정책이 적용되어 다운로드할 수 없습니다.',
  RestoreDocumentSuccessMessage: '${title} 가 복원되었습니다.',
  RestoreVersionNumberButtonText: '버전 ${versionNumber} 복원',
  HistoryDialogNothingChangeMessage:
    '이 버전은 현재 버전과 동일합니다.',
  HistoryDialogNoDocumentChangeMessage: '문서 내용이 변경되지 않았습니다.',
  HistoryDialogNoNameAndNumberChangeMessage:
    '문서의 이름과 번호는 변경되지 않았습니다.',
  ResetViewAsToDownload: '다운로드하려면 "보기" 필터를 재설정하세요.',
  NoPermissionToDownloadTooltip:
    '관리자가 이 방에 대한 대량 다운로드를 비활성화했습니다.',
  Remove: '제거하다',
  Reset: '다시 놓기',
  ResetNow: '지금 재설정',
  ResetDialogTitle: '제출 프로세스 재설정',
  ResetDialogContent:
    '제출 프로세스를 재설정하시겠습니까? 마감일과 시간이 재설정됩니다.',
  Confirm: '확인하다',
  Region: '지역',
  KiraSuccessfullyConnectedTitle: 'Kira 에 성공적으로 연결되었습니다',
  KiraSuccessfullyConnectedFirstLine:
    '이제 Kira 에 문서를 보내어 발견할 수 있습니다.',
  KiraSuccessfullyConnectedSecondLine:
    '계약서 및 관련 문서로부터 관련 정보를 얻습니다.',
  KiraProjectsLoading: '프로젝트 로딩 중...',
  KiraSelectProject: 'Kira 에서 프로젝트를 선택하세요...',
  KiraSendDocument: 'Kira 에게 문서 보내기',
  KiraConnect: '키라에 연결',
  KiraCompanyUrl: '귀하의 Kira 회사 URL',
  KiraApiToken: 'Kira API 토큰',
  KiraUnableToConnect:
    'Kira 에 연결할 수 없습니다. 지역과 토큰을 확인하고 다시 시도하세요.',
  KiraConfigError:
    '구성을 로드하는 중에 오류가 발생했습니다. 다시 시도해 주세요.',
  KiraProjectsLoadError:
    'Kira 에서 프로젝트를 가져올 수 없습니다. 다시 시도해 주세요.',
  KiraSendDocumentError:
    'Kira 에게 문서를 푸시하는 중에 오류가 발생했습니다. 다시 시도해 주세요.',
  KiraSendingDocument: "Kira 에게 '${documentName}' 를 보내는 중",
  KiraDocumentSent: "'${documentName}' 가 Kira 에게 전송되었습니다.",
  Redact: '삭제하다',
  RedactDocuments: '문서 삭제',
  EditRedact: '편집 편집',
  RedactionIsNotAvailable: '편집이 불가능합니다.',
  RedactGetDocumentError:
    '이 문서를 가져올 수 없습니다. 다시 시도해 주세요.',
  RedactBurnDocumentError:
    '이 문서를 삭제할 수 없습니다. 다시 시도해 주세요.',
  RedactFileTooLarge:
    '${fileSize} 보다 큰 파일은 현재 편집이 지원되지 않습니다. 문서 크기를 최적화하고 다시 시도하세요.',
  RedactSaveDialogTitle: '새로운 편집된 문서로 저장',
  MultipleDocumentsErrorDescription:
   '${numberOfDocuments}로 표시된 문서는 처리할 수 없습니다. 문서를 다시 업로드해 보세요.',
  SingleDocumentErrorDescription:
    '1개의 문서가 처리되지 않았습니다. 문서를 다시 업로드해 보세요.',
  MultipleDocumentsInProgressDescription:
    '${numberOfDocuments} 문서는 처리가 완료되지 않은 것으로 표시되었습니다.',
  SingleDocumentInProgressDescription:
    '1 개 문서가 처리가 완료되지 않았습니다.',
  CancelBulkRedaction: '대량 편집 취소',
  CancelBulkRedactionMessage: `수정 프로세스를 중지하려고 합니다. 수정을 중지하면 현재 문서의 수정이 중단되고 문서 인덱스로 돌아갑니다.`,
  StopRedaction: '편집 중지',
  DocumentLocation: '문서 위치',
  SecurityControls: '보안 제어',
  SecuritySettings: '보안 설정',
  UseFolderSecurityFrom: '폴더 보안 설정을 사용하세요',
  UseSecurityFromOpenedDocument: '열린 문서의 보안 설정 사용',
  UseSecurityFromOriginalDocument:
    '원본 문서의 보안 설정 사용',
  UseSecurityFromOriginalFolder: '원래 폴더의 보안 설정 사용',
  UseSecurityFromOriginalFoldersAndDocuments:
    '원본 폴더 및 원본 문서의 보안 설정 사용',
  DocumentWillBeDisabledByDefault: '문서는 기본적으로 비활성화됩니다.',
  DocumentsAndFoldersWillBeDisabledByDefault:
    '폴더와 문서는 기본적으로 비활성화됩니다.',
  ImportDataRoomError:
    '추적 ID ${trackingId} 로 가져오기는 오류입니다. 다시 시도하세요.',
  RedactionError: '${fileName} 를 수정할 수 없습니다. 다시 시도하세요.',
  RedactionHowRedactionSavingWorks: '편집 저장 작동 방식',
  RedactionEducationDialogForAdministrators: '관리자를 위해',
  RedactionEducationDialogForGuests: '손님을 위해',
  RedactionEducationDialogPreviewDownload: '미리보기/다운로드',
  RedactionEducationDialogEditing: '편집 중',
  RedactionEducationDialog1Layer: '1-레이어 문서',
  RedactionEducationDialog2Layer: '2층 문서',
  RedactionEducationDialogRedactionsAreBakedIn: '편집이 내장되어 있습니다',
  RedactionEducationDialogRedactionsAreEditable: '편집 가능한 편집 내용',
  RedactionSaveAsNewDocument: '새 문서로 저장',
  RedactionHowSavingWorks: '저축이 작동하는 방식',
  ChangesYouMadedWillNotBeSaved: '변경한 내용은 저장되지 않습니다.',
  IsRedacted: '편집되었습니다.',
  DocumentsAddedFrom: '${dataroomName} 에서 문서가 추가되었습니다.',
  GoToFile: '나에게 문서를 보여주세요',
  GoToImportFolder: '폴더를 보여주세요',
  Thanks: '감사해요',
  Validation_DuplicatedDocumentInFolder:
    '문서 ${documentName} 가 이미 ${folderName} 에 있습니다.',
  Validation_NameCannotBeEmpty: '이름은 비워둘 수 없습니다.',
  Continue: '계속하다',
  RedactingMessage: '수정하는 데 시간이 걸릴 수 있습니다. 새로 고침하지 마십시오.',
  Name: '이름',
  Number: '숫자',
  LearnMore: '더 알아보기',
  BulkActionsNoItemsWillBeAffected:
    '이 작업은 어떤 항목에도 영향을 미치지 않습니다.',
  Saving: '절약',
  YouCanKeepWorking: '계속 일할 수 있어요.',
  Copy: '복사',
  CopyDocumentTo: '문서를 복사합니다',
  CopyFolderTo: '폴더 복사하기',
  Import: '수입',
  DataRooms: '데이터룸',
  Accept: '수용하다',
  TermOfAccess: '접근 조건',
  TermOfAccessCheckbox: '나는 약관을 읽고 이해했으며 동의합니다.',
  ImportingDataFrom: '${dataroomName} 에서 문서를 추가합니다.',
  Refresh: '새로 고치다',
  ImportTo: '가져오기',
  ImportError: '가져오기 오류가 발생했습니다. 관리자에게 문의하세요.',
  Back: '뒤쪽에',
  LastAccessed: '접근됨',
  NeverAccessed: '접근한 적이 없음',
  Remaining: '남은',
  SubmissionWindowIsOpen: '제출 기간이 시작되었습니다.',
  SubmissionWindowHasEnd:
    '제출 기간이 종료되었습니다. 지금 업로드하는 문서는 늦은 것으로 표시됩니다.',
  FromYourComputer: '컴퓨터에서',
  FromAnotherDataRoom: '다른 데이터 룸에서',
  FromFolderStructure: '폴더 구조에서',
  FromDataRoom: '데이터 룸에서',
  AddFromDataRoom: '데이터룸에서 추가',
  AddFromFolderStructure: '폴더 구조에서 추가',
  ImportDialogDataRoomScreenDialogTitle: '데이터룸에서 문서 추가',
  ImportDialogDataRoomScreenHeading:
    '추가하려는 문서가 있는 데이터룸을 선택하세요.',
  ImportDialogTermOfAccessScreenDialogTitle:
    '${dataroomName} 에서 문서 추가',
  ImportDialogTermOfAccessScreenHeading:
    '이 데이터룸에서 문서를 추가하려면 먼저 이용 약관에 동의해야 합니다.',
  ImportDialogDataRoomScreenRadioBtn: '이 데이터 룸에서 문서를 추가하세요',
  ImportDialogDocumentListScreenHeading:
    '데이터룸에 추가할 문서를 하나 이상 선택하세요.',
  ImportDialogEmptyDataRoom: '접근할 수 있는 데이터 룸이 없습니다.',
  ImportDialogEmptyDocument:
    '이 데이터룸에서 추가할 문서가 없습니다.',
  ImportDialogDocumentListScreenDialogTitle:
    '${dataroomName} 에서 문서 추가',
  UserTypeCode_ADM: '관리자',
  UserTypeCode_DOP: '발행자',
  UserTypeCode_GUE: '손님',
  UserTypeCode_USQ: '제한된 뷰어',
  UserTypeCode_USR: '뷰어',
  QnaRoleCode_QVW: '질문 뷰어',
  QnaRoleCode_BAP: '입찰자 승인자',
  QnaRoleCode_BAA: '입찰자 작성자',
  QnaRoleCode_BMC: '입찰자 주요 연락처',
  QnaRoleCode_IAP: '내부 승인자',
  QnaRoleCode_IAA: '내부 작성자',
  QnaRoleCode_IMC: '내부 주요 연락처',
  QnaRoleCode_IOB: '내부 관찰자',
  QnaRoleCode_QAU: '질문 작성자',
  QnaRoleCode_QAP: '질문 승인자',
  QnaRoleCode_ADR: '답변 작성자',
  QnaRoleCode_AAU: '답변 작성자',
  QnaRoleCode_AAP: '답변 승인자',
  QnaRoleCode_QAA: 'Q&A 관리자',
  QnaRoleCode_QAO: 'Q&A Observer 전체 제어',
  QnaRoleCode_QOV: 'Q&A Observer View 전용',
  DemoRoom: '*데모* - ${dataroomName}',
  SearchDocuments_InputPlaceholder:
    '키워드, 또는 문서나 폴더의 이름과 번호를 입력하세요',
  SearchDocuments_Find: '찾다',
  SearchDocuments_Results: '결과',
  SearchDocuments_FullTextSearchSummary:
    '${totalItems} 문서${plural} 는 콘텐츠와 일치합니다.',
  SearchDocuments_DocumentSummary:
    '${totalItems} 문서${plural} 는 제목과 번호 및 코드를 일치시킵니다.',
  SearchDocuments_FolderSummary:
    '${totalItems} 폴더${plural} 는 제목과 번호 및 코드를 일치시킵니다.',
  New: '새로운',
  Browse: '먹다',
  ImportFolder_GlobalActionButton: '폴더 구조 가져오기',
  ImportFolder_Title: '폴더 구조를 가져오세요',
  ImportFolder_Step1_DragDropDescription1:
    'Excel 파일을 끌어서 놓거나 검색하여 폴더를 가져옵니다.',
  ImportFolder_Step1_DragDropDescription2:
    '참고: 가져오기 시 폴더는 비활성화됩니다.',
  ImportFolder_Step1_DragDropDescription3:
    '폴더 번호를 열 A로, 폴더 이름을 열 B로 지정하거나 간단히 {0}로 Excel 파일을 포맷하세요.',
  ImportFolder_Step1_FileUploaded: '{0} 업로드됨',
  ImportFolder_Step1_DownloadTemplateFile: '엑셀 템플릿 다운로드',
  ImportFolder_Step1_Heading: '{0}로 폴더 구조를 가져오고 있습니다.',
  ImportFolder_Step1_ErrorMessage:
    '파일이 업로드되지 않았습니다. .xls 또는 .xlsx 파일로 다시 시도하세요.',
  ImportFolder_Step2_Title: '가져오기를 검토하고 완료하세요',
  ImportFolder_Step2_SuccessMessage: '폴더를 가져왔습니다.',
  Document_Preview: '문서 미리보기',
  FileUnsupportedForPreview: `이 파일의 미리보기를 보여드릴 수 없습니다. 내용을 보려면 파일을 다운로드해야 합니다.`,
  ErrorWhileDownloadingFile:
    '다운로드를 시도하는 동안 오류가 발생했습니다. ${ErrorCode} 로 고객 지원팀에 문의하세요.',
  CannotDownloadingFile: "파일을 다운로드할 수 없습니다. ",
  ClickToSeeDetails: '자세한 내용을 보려면 클릭하세요',
  TryAgain: '다시 시도하세요',
  NumberingUpdatedFor: '번호 매기기가 업데이트되었습니다.',
  Items: '아이템',
  YoureAboutToChangeTheNumberingOn: "번호를 변경하려고 합니다.",
  ThisMayHaveAnImpactOnPeopleReferencingTheDocumentOnThisProject:
    '이는 이 프로젝트에서 해당 문서를 참조하는 사람들에게 영향을 미칠 수 있습니다.',
  AllDocuments: '모든 문서',
  AllQnaAndAttachments: '모든 Q&A 및 첨부파일',
  AllSubmissionDocuments: '모든 제출 서류',
  AllEvaluationAttachments: '모든 평가 첨부 파일',
  AllUserActivityDocumentViewsReports:
    '사람별 모든 활동 로그 및 문서 보기 보고서',
  IncludeDocuments: '문서 포함',
  IncludeSubmissionDocuments: '제출 문서 포함',
  IncludeEvaluationAttachments: '평가 첨부 파일 포함',
  IncludeQna: 'Q&A 포함',
  IncludeQnaAttachments: 'Q&A 첨부파일 포함',
  IncludeDisabledDocuments: '비활성화된 문서 포함',
  Documents: '서류',
  SubmissionDocuments: '제출서류',
  EvaluationAttachments: '평가 첨부 파일',
  QnaAttachments: 'Q&A 첨부파일',
  DisabledDocuments: '비활성화된 문서',
  DocumentsVisibleTo: '볼 수 있는 문서',
  SubmissionDocumentsVisibleTo: '제출 문서가 표시됩니다.',
  QnaAndAttachmentsVisibleTo: 'Q&A 및 첨부파일은 다음에서 볼 수 있습니다.',
  QnaAttachmentsVisibleTo: 'Q&A 첨부파일이 표시됩니다.',
  QnaVisibleTo: 'Q&A는 다음에서 볼 수 있습니다.',
  IncludeDisabledDocumentsWarningMessage:
    '비활성화된 문서를 포함하면 선택한 팀에 현재 표시되지 않는 문서가 표시됩니다. 이 옵션은 권장되지 않습니다.',
  AllSubTeams: '모든 하위 팀',
  AllSecurityGroups: '모든 보안 그룹',
  NoSubTeams: '하위 팀 없음',
  AdminOnlyFullArchive: '관리자 전용 - 전체 보관함',
  Team: '팀',
  SubTeam: '하위팀',
  ArchiveName: '아카이브 이름',
  Options: '옵션',
  Summary: '요약',
  CreateArchive: '아카이브 만들기',
  IncludeInArchive: '보관함에 포함',
  VisibleTo: '볼 수 있는',
  SubmissionDocuments_LowerCase: '제출 서류',
  EvaluationAttachments_LowerCase: '평가 첨부 파일',
  Qna: '질문과답변',
  QnaAndAttachments_LowerCase: 'Q&A 첨부파일',
  DisableDocuments_LowerCase: '비활성화된 문서',
  Questions_LowerCase: '질문',
  Attachments_LowerCase: '첨부파일',
  DocumentViewsReports_LowerCase: '문서 뷰 보고서',
  ActivityLogsByPerson_LowerCase: '사람별 활동 로그',
  InProgress: '진행중',
  Expired: '만료됨',
  Failed: '실패한',
  YourArchiveIsBeingGenerated: '보관 파일을 생성 중입니다...',
  YourArchiveHasBeenQueued: '보관 파일이 대기 중입니다.',
  AnEmailWillBeSentTo: '이메일이 전송됩니다',
  WithADownloadLinkWhenTheArchiveIsReady:
    '보관 파일이 준비되면 다운로드 링크도 제공해 드립니다.',
  ContactSupport: '지원팀에 문의하세요',
  SomethingWentWrong: '문제가 발생했습니다.',
  WeAreUnableToProcessYourArchiveRequest:
    '귀하의 보관 요청을 처리할 수 없습니다.',
  Retrieving: '검색 중',
  FullArchiveAdminOnly: '전체 보관함 - 관리자 전용',
  Filtered: '거르는',
  CreateYourFirstArchive: '첫 번째 보관소를 만들어보세요.',
  AutoTruncateHelpText:
    "파일 경로가 260자를 넘지 않도록 최적의 잘라내기를 적용하겠습니다.",
  Becomes_LowerCase: '된다',
  TruncationType: '절단 유형',
  AutoTruncate: '자동 잘라내기',
  DoNotTruncate: '잘라내지 마세요',
  KeepLastSegmentOfNumbers: '숫자의 마지막 부분을 유지하세요',
  KeepNumbersOnly: '숫자만 유지',
  KeepNamesOnly: '이름만 유지',
  FullArchiveHelpText:
    '데이터룸 관리자는 모든 문서와 Q&A 첨부 파일을 볼 수 있습니다.',
  ArchiveHelpText:
    '${teamOrSubTeamName} 에서 볼 수 있는 ${includedOptions} 를 포함하겠습니다.',
  HowArchivesWork: '아카이브는 어떻게 작동하나요?',
  ArchivesContainTheFullFilePathForEveryArchivedDocument:
    '보관소에는 보관된 모든 문서의 전체 파일 경로가 포함되어 있습니다.',
  FilePathsAreLimitedTo260Characters:
    '파일 경로는 260 자로 제한됩니다.',
  YouMayNeedToTruncateTheFilePaths:
    '컴퓨터에서 파일을 보려면 파일 경로를 잘라야 할 수도 있습니다.',
  YouCanUseAZipApplicationToViewArchivesWithLongFilePaths:
    '혹은, ZIP 애플리케이션을 사용하여 파일 경로가 긴 보관 파일을 볼 수 있습니다.',
  YourArchiveIsDownloading: '보관 파일을 다운로드하는 중입니다.',
  DoNotTruncateHelpText:
    'ZIP 애플리케이션을 사용하면 파일 경로가 긴 문서를 추출할 수 있습니다.',
  Share: '공유하다',
  SecureShare_Capitalize: '보안 공유',
  SecureShare_SentenceCase: '보안 공유',
  ValidateEmailToView: '이메일을 확인하여 확인하세요',
  ValidateEmailToViewDescription:
    '사람들은 문서를 보기 전에 이메일 주소를 확인해야 합니다.',
  EnterPasscodeToView: '암호를 입력하여 확인하세요',
  EnterPasscodeToViewDescription:
    '사람들이 문서를 보려면 먼저 입력해야 하는 암호를 설정합니다.',
  AnyoneWithALinkCanView: '링크가 있는 사람은 누구나 볼 수 있습니다',
  AnyoneWithALinkCanViewDescription:
    '링크가 있는 사람은 해당 문서에 보안되지 않은 방식으로 접근할 수 있습니다.',
  NoAccess: '접근 불가',
  NoAccessDescription:
    '공유 링크가 있는 사람들은 더 이상 문서를 볼 수 없습니다.',
  SecureShareLinkSettings: '공유 링크에 대한 액세스 제어',
  Watermark: '양수표',
  LinkExpiresIn: '링크가 ${duration} (${timezone})에 만료됩니다.',
  LinkExpiredDuration: '링크가 만료되었습니다 ${duration} 전 (${timezone})',
  LinkExpirationDate: '링크 만료 날짜와 시간을 설정하세요',
  On: '~에',
  Off: '끄다',
  CreateWatermark: '워터마크 생성',
  None: '없음',
  YouAreReadyToShare: '이제 공유할 준비가 되었습니다',
  WeHaveCopiedTheSecureShareLinkToYourClipboard:
    '<strong data-ansarada-ccd="true">${fileName}</strong> 에 대한 보안 링크를 클립보드에 복사했습니다.',
  AnyoneWithTheLinkCanviewTheDocument:
    '링크가 있는 사람은 누구나 문서를 볼 수 있습니다.',
  PeopleNeedToValidateTheirEmailToViewTheDocument:
    '사람들은 문서를 보려면 이메일을 인증해야 합니다.',
  PeopleNeedToEnterThePasscodeToViewTheDocument:
    '사람들은 문서를 보려면 암호( <strong data-ansarada-ccd="true">${passCode}</strong> )를 입력해야 합니다.',
  SecureShareLink: '보안 공유 링크',
  SecureShareLinkCopy: '복사하고 공유할 수 있는 보안 링크',
  SaveAndRemoveAccess_SentenceCase: '저장 및 액세스 제거',
  AccessPasscode: '링크에 접근하려면 암호를 입력하세요',
  SettingsSaved: '설정이 저장되었습니다',
  WeHaveExpiredAllSecureShareLinks:
    '<strong data-ansarada-ccd="true">${fileName}</strong> 에 대한 모든 보안 공유 링크가 만료되었습니다.',
  LinkShareWithCode: '코드로 링크 공유',
  LinkShareWithEmail: '이메일로 링크 공유',
  LinkShare: '링크 공유',
  AllDownloadedCopiesWillSelfDestruct:
    '다운로드한 모든 사본은 자동으로 파기됩니다.',
  NeedHelpSharingALinkOrDocument: '링크나 문서를 공유하는 데 도움이 필요하신가요?',
  HowDoIExpireAllLinksToADocument: '문서에 대한 모든 링크를 만료하려면 어떻게 해야 하나요?',
  WhatDoIDoToDenyADownload: '다운로드를 거부하려면 어떻게 해야 하나요?',
  FindOutMoreAboutSecureShare: '문서를 안전하게 공유하는 방법에 대해 자세히 알아보세요',
  SaveAndCopyLink_SentenceCase: '링크를 저장하고 복사하세요',
  ShareDocumentSecurely_SentenceCase: '문서를 안전하게 공유하세요',
  ShareDocumentEmptyStateDescription:
    '문서 관리 열에서 문서를 선택하여 공유를 시작하세요.',
  FirstTellUsWhoYouAre: '먼저, 당신이 누구인지 말해주세요',
  ToAccessTheSharedDocumentWeNeedToVerifyYourEmailAddress:
    '공유 문서에 액세스하려면 이메일 주소를 확인해야 합니다.',
  WeWillSendYouAnEmailSoYouCanAccessTheSharedDocument:
    '공유 문서에 접근할 수 있도록 이메일을 보내드리겠습니다.',
  EnterAnEmailAddress: '이메일 주소를 입력하세요',
  EnterAValidEmailAddress: '유효한 이메일 주소를 입력하세요',
  EmailIsRequired: '이메일이 필요합니다',
  VerifyMyEmail_SentenceCase: '내 이메일 확인',
  FirstEnterThePasscode: '먼저 비밀번호를 입력하세요',
  ToAccessTheSharedDocumentYouNeedToEnterThePasscode:
    '공유 문서에 접근하려면 암호를 입력해야 합니다.',
  ReachOutToThePersonWhoSharedDocumentYouNeedToEnterThePasscode:
    '자세한 내용을 알아보려면 링크를 공유한 사람에게 연락하세요.',
  EnterTheAccessPasscode: '접속 비밀번호를 입력하세요',
  ViewDocument_SentenceCase: '문서 보기',
  TheDocumentIsNoLongerAvailable: '해당 문서는 더 이상 사용할 수 없습니다.',
  YourAccessMayHaveBeenRemovedOrTheDocumentDeleted:
    '귀하의 접근 권한이 제거되었거나 문서가 삭제되었을 수 있습니다.',
  ReachOutToThePersonWhoSharedTheLinkWithYouToFindOutMore:
    '자세한 내용을 알아보려면 링크를 공유한 사람에게 연락하세요.',
  SecurityControlsOn: '보안 제어 켜짐',
  SecurityControlsOff: '보안 제어 해제',
  CopyingAllowed: '복사 허용',
  CopyingDenied: '복사 거부됨',
  EditingAllowed: '편집 허용',
  EditingDenied: '편집 거부됨',
  DenyCopyingDisabled: '복사 거부 비활성화됨',
  DenyEditingDisabled: '편집 거부 비활성화됨',
  DenyPrintingDisabled: '인쇄 거부 비활성화됨',
  DenySavingDisabled: '저장 거부 비활성화됨',
  Redirecting: '리디렉션 중...',
  CheckYourInbox: '받은 편지함을 확인하세요',
  YouAreOnADifferentDevice: '다른 기기를 사용하고 있습니다',
  YouCanOnlyViewThisDocumentFromTheSameDeviceUsedToVerifyYourEmail:
    '이 문서는 이메일을 인증하는 데 사용한 장치에서만 볼 수 있습니다.',
  WeHaveSentAnEmailToYourEmail: '우리는 이메일을 보냈습니다 ',
  WithTheAccessToViewTheDocument: ' 문서를 볼 수 있는 권한이 있습니다.',
  ViewActivity: '활동 보기',
  PasscodeIsNotCorrect: '비밀번호가 올바르지 않습니다',
  SubmissionDocumentUploaded: '1개 문서가 제출에 업로드되었습니다.',
  SubmissionDocumentsUploaded:
    '${NumberOfDocuments} 문서가 제출에 업로드되었습니다.',
  HowSubmissionsWork: '제출 방법',
  AllAddedDocumentsAreAutomaticallySubmitted:
    '추가된 모든 문서는 자동으로 제출됩니다.',
  YouHaveUntilTheCloseOfTheSubmissionWindowToMakeChanges:
    '제출 기간이 종료되기 전까지 변경이 가능합니다.',
  UntilClose: '닫을 때까지',
  Ansarada: '안사라다',
  BulkEditFileUpload: `또는 정제된 Excel 을 여기로 끌어다 놓으세요. 편집 내용에 대한 명확한 개요를 보여드리겠습니다.`,
  BulkEditFileUploadAfterUploading:
    '또는 올바른 파일을 여기로 끌어서 놓으면 원활하게 전환할 수 있습니다.',
  BulkEditExcelReady: '요점에 맞춰, ${name}! 편집된 Excel 이 준비되었나요?',
  BeforeYourEdits: '편집하기 전에',
  AfterYourEdits: '편집 후',
  DropFilesHereToAttach: '파일을 여기에 놓아 첨부하세요',
  KickOffBy: '시작',
  DownloadingTheExcelVersion: 'Excel 버전 다운로드',
  OfYourDocumentIndex: '문서 색인의.',
  BulkEditNextButtonGuide:
    '세부 조정 후 <strong>다음</strong> 버튼을 눌러 업로드하고 실제 효율성을 확인하세요.',
  BulkEditDownloadExcelFileHeading:
    '워크플로우를 한 단계 업그레이드하세요: 더욱 매끄러워진 문서 편집.',
  BulkEditAllSetHeading: "모두 준비되었습니다, ${name}! 행동할 준비가 되었습니다.",
  BulkEditButtonGuide:
    "<strong>대량 편집</strong> 버튼을 누르면 귀하의 지시에 따라 ${combinedText} 를 조정할 준비가 됩니다.",
  HeadsUpThough: `<strong>미리 알려드립니다.</strong> 최소한 한 번은 수정하지 않을 겁니다. 관리자가 문서 인덱스에서 삭제했습니다.`,
  ProTip: '전문가의 조언?',
  ProTipDescription:
    "문서 색인의 최신 Excel 버전을 다운로드하는 것을 고려하세요. 편집이 시작되기 전에 깨끗한 스냅샷을 볼 수 있습니다.",
  GrabItHere: '여기서 받으세요.',
  BulkEditSuccessMessage: `대량 업데이트가 적용되었고 이제 문서 인덱스에 있습니다. 저희가 당신을 지원합니다!`,
  NotTheRightExcel: '적합한 Excel이 아닌가요?',
  UploadFailedMessage:
    '업로드 실패, ${name}. 업로드하는 동안 문제가 발생했습니다. 다시 시도하세요.',
  FailedMessage:
    '업데이트 실패, ${name}. 대량 업데이트에 문제가 발생했습니다. 다시 시도하세요.',
  DoNotHaveAccessMessage:
    '제공된 Excel 에서 변경된 일부 문서 및 폴더에 액세스할 수 없습니다. Data Room 관리자에게 작업을 수행하도록 요청하세요.',
};
